"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearcherFormMobileLayout = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
require("react-responsive-modal/styles.css");
var _reactResponsiveModal = require("react-responsive-modal");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _userflow = require("../../icons-react/userflow");
var _Button = _interopRequireDefault(require("../Button"));
var _userAgentUtils = require("../../utils/userAgentUtils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SearcherFormMobileLayout = exports.SearcherFormMobileLayout = /*#__PURE__*/_react["default"].memo(function (props) {
  var open = props.open,
    children = props.children,
    popupLabel = props.popupLabel,
    onSubmit = props.onSubmit,
    submitButtonText = props.submitButtonText,
    containerStyles = props.containerStyles,
    container = props.container,
    _props$onCancel = props.onCancel,
    onCancel = _props$onCancel === void 0 ? function () {
      return {};
    } : _props$onCancel,
    withHeader = props.withHeader;
  var hasSubmitButton = Boolean(submitButtonText);

  // Используются inline стили, так как react-responsive-modal не может в Styled components:
  var Styles = _objectSpread({
    position: 'relative',
    flexDirection: 'column',
    display: 'flex',
    width: '100vw',
    height: '100%',
    margin: 0,
    padding: 0,
    zIndex: 12000
  }, withHeader ? {
    background: ' #f5f4f2'
  } : {});
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_reactResponsiveModal.Modal, (0, _extends2["default"])({}, props, {
    container: container || undefined,
    styles: {
      modal: Styles,
      overlay: {
        padding: 0,
        background: '#FFFF00',
        zIndex: 12000
      }
    },
    open: open,
    onClose: onCancel,
    showCloseIcon: false,
    blockScroll: !_userAgentUtils.iOSSafari
  }), withHeader ? /*#__PURE__*/_react["default"].createElement(StyledHeader, null, /*#__PURE__*/_react["default"].createElement(StyledCloseIcon, {
    onClick: onCancel
  })) : /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledLabel, null, popupLabel), /*#__PURE__*/_react["default"].createElement(StyledCancelButton, {
    onClick: onCancel,
    type: "button"
  }, t('touristsPicker.button.cancel'))), /*#__PURE__*/_react["default"].createElement(StyledBody, null, /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    hasSubmitButton: hasSubmitButton,
    containerStyles: containerStyles,
    withHeader: withHeader
  }, children), submitButtonText ? /*#__PURE__*/_react["default"].createElement(StyledButtonContainer, null, /*#__PURE__*/_react["default"].createElement(StyledSubmitButton, {
    onClick: onSubmit,
    withHeader: withHeader
  }, submitButtonText)) : null));
});
SearcherFormMobileLayout.displayName = 'SearcherFormMobileLayout';
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormMobileLayout__StyledWrapper",
  componentId: "sc-ffhmrx-0"
})(["position:relative;text-align:center;font-size:16px;display:flex;align-items:flex-end;justify-content:flex-end;margin-block-start:0;margin-block-end:0;padding:14px 8px;"]);
var StyledLabel = _styledComponents["default"].span.withConfig({
  displayName: "SearcherFormMobileLayout__StyledLabel",
  componentId: "sc-ffhmrx-1"
})(["position:absolute;transform:translate(-50%,0);left:50%;"]);
var StyledCancelButton = _styledComponents["default"].button.withConfig({
  displayName: "SearcherFormMobileLayout__StyledCancelButton",
  componentId: "sc-ffhmrx-2"
})(["line-height:16px;font-size:12px;border:none;background:transparent;color:", ";cursor:pointer;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blue;
});
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormMobileLayout__StyledContainer",
  componentId: "sc-ffhmrx-3"
})(["max-height:calc( 100% - ", "px );overflow-y:auto;", ";", ""], function (_ref2) {
  var hasSubmitButton = _ref2.hasSubmitButton;
  return hasSubmitButton ? 95 : 45;
}, function (_ref3) {
  var containerStyles = _ref3.containerStyles;
  return containerStyles;
}, function (_ref4) {
  var withHeader = _ref4.withHeader;
  return withHeader && "margin-top: 8px;";
});
var StyledButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormMobileLayout__StyledButtonContainer",
  componentId: "sc-ffhmrx-4"
})(["margin-top:auto;margin-bottom:8px;padding:0 8px;width:100%;"]);
var StyledSubmitButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "SearcherFormMobileLayout__StyledSubmitButton",
  componentId: "sc-ffhmrx-5"
})(["font-size:16px;line-height:20px;background-color:#fff;width:100%;", ""], function (_ref5) {
  var withHeader = _ref5.withHeader;
  return withHeader && "\n    background: #007aff;\n    border-radius: 4px;\n    color: #fff !important;\n\n    &:hover {\n      color: #fff;\n    }\n  ";
});
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormMobileLayout__StyledHeader",
  componentId: "sc-ffhmrx-6"
})(["height:56px;background:#f5f4f2;display:flex;justify-content:flex-end;"]);
var StyledCloseIcon = (0, _styledComponents["default"])(_userflow.CloseThin).withConfig({
  displayName: "SearcherFormMobileLayout__StyledCloseIcon",
  componentId: "sc-ffhmrx-7"
})(["width:16px;height:16px;margin-top:20px;margin-right:12px;> path{stroke:#919499;}"]);
var StyledBody = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormMobileLayout__StyledBody",
  componentId: "sc-ffhmrx-8"
})(["background:#fff;border-radius:8px 8px 0 0;height:100%;display:flex;flex-direction:column;"]);